/**
 * The CANONICAL form of a document reference — the one form every comparison and
 * every per-document memo in the app keys on.
 *
 * A document reference is a `did:ng:o:<repo>[:v:<overlay>]`. The SAME document can
 * legitimately be named with or without its `:v:<overlay>` suffix depending on
 * which boundary handed it over (a create, a listing, a read subject). Two forms
 * of one document must never become two entries anywhere: two owned events, two
 * counts — or, the defect this file was extracted for, two INBOXES for one
 * document, one of which nobody reads.
 *
 * A reference with no `:v:` overlay (or one that is not a `did:ng:o:` id at all)
 * passes through unchanged.
 *
 * `canonicalEventId` (data/registration) is this function under the name the event
 * call sites use; it is re-exported there, not reimplemented.
 */
export function canonicalDocumentId(id: string): string {
  // did:ng:o:<repo>:v:<overlay> → did:ng:o:<repo>. The overlay segment is the
  // LAST `:v:`-introduced part; a base id (`did:ng:o:<repo>`) has no `:v:`.
  const i = id.indexOf(':v:');
  return i === -1 ? id : id.slice(0, i);
}
